import {
	createSlice,
	createSelector,
	createEntityAdapter
} from '@reduxjs/toolkit';
import { generateId } from '../../utils/helperFunctions';

const staffAdapter = createEntityAdapter({
	// generate and return a unique id for each staff member
	selectId: (data) => {
		const staffMember = { ...data };
		if (!staffMember.id) {
			staffMember.id = generateId();
		}
		return staffMember.id;
	}
});

const initialState = staffAdapter.getInitialState({});

const staffSlice = createSlice({
	name: 'staff',
	initialState,
	reducers: {
		setStaffMembers(state, action) {
			const staff = action.payload;
			staffAdapter.upsertMany(state, staff);
		}
	}
});

export const {
	selectAll: selectAllStaff,
	selectById: selectStaffId,
	selectIds: selectStaffIds
} = staffAdapter.getSelectors((state) => state.staff);

export const selectStaffMembersByDepartment = createSelector(
	[selectAllStaff, (state, departmentId) => departmentId],
	(staff, departmentId) =>
		staff.filter((staffMember) => staffMember.department === departmentId)
);

export const { setStaffMembers } = staffSlice.actions;

export default staffSlice.reducer;
